import apiClient from '../apiClient';

/**
 * Fetch analytics summary for the supplier owner with a time-range filter.
 * @param {string} startDate - ISO 8601 string (e.g. "2026-04-24T00:00:00Z")
 * @param {string} endDate   - ISO 8601 string (e.g. "2026-04-24T23:59:59Z")
 */
export const getAnalyticsSummary = async (startDate, endDate) => {
    const response = await apiClient.get('/analytics/summary', {
        params: { startDate, endDate },
    });
    return response.data;
};

/**
 * Fetch personal analytics summary for the authenticated sales person.
 * @param {string} startDate - ISO 8601 string
 * @param {string} endDate   - ISO 8601 string
 */
export const getSalesPersonAnalyticsSummary = async (startDate, endDate) => {
    const response = await apiClient.get('/analytics/sales-person-summary', {
        params: { startDate, endDate },
    });
    return response.data;
};
